
import appConfig from '../app-config';

export const logInfo = (message) => {
  if (appConfig.environment === 'local' || appConfig.environment === 'development')
    console.log(message);
};

export const logError = (error) => {
  if (appConfig.environment === 'local' || appConfig.environment === 'development')
    console.error(error);
};

export const convertBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file)
    fileReader.onload = () => {
      resolve(fileReader.result);
    }
    fileReader.onerror = (error) => {
      reject(error);
    }
  })
}

export function shuffle(array) {
  let currentIndex = array.length;

  while (currentIndex !== 0) {

    let randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }
}